function wishlist() {
	var cookieName = "wishlistList";
	$(document).on('click', '.addto-wishlist', function (e) {
		e.preventDefault();
		var id = $(this).attr('rel');
		if ($.cookie(cookieName) == null) {
			var str = '__' + id;
		} else {
			if ($.cookie(cookieName).indexOf(id) == -1) {
				var str = $.cookie(cookieName) + '__' + id;
				str = str.replace('____', '__');
			}
		}
		$.cookie(cookieName, str, { expires: 30, path: '/' });
		$(this).find(".ad").removeClass('ad-heart-l').addClass('ad-circle-notch-r ad-spin');
		setTimeout(function () {
			$('.wishlist[rel="' + id + '"]').removeClass('addto-wishlist').find('span').text(theme.wlAvailable);
			$('.wishlist[rel="' + id + '"] .ad').removeClass('ad-circle-notch-r ad-spin').addClass('ad-heart');
			updateWishlist();
		}, 2000);
	});
}
function updateWishlist() {
	var cookieName = "wishlistList";
	try {
		if ($.cookie(cookieName) != null && $.cookie(cookieName) != '__' && $.cookie(cookieName) != '') {
			var str = String($.cookie(cookieName)).split("__");
			for (var i = 0; i < str.length; i++) {
				if (str[i] != '') {
					let addedMsg = $('.wishlist[rel="' + str[i] + '"] .msg').attr('data-msg-change');
					$('.wishlist[rel="' + str[i] + '"]').find('span').text(addedMsg);
				}
			}
			wishlistCount();
		}
	}
	catch (err) { }
}
function wishlistCount() {
	var cookieName = "wishlistList";
	var str = String($.cookie(cookieName)).split("__");
	for (var i = 0; i < str.length; i++) {
		if (str[i] != '') {
			$('.favCount').text(i).removeClass('hide');
		}
	}
}
$(document).ready(function () {
	wishlist();
	wishlistCount();
});